import React from 'react';

//Constructor but uses a state to figure out if its been run or not, since functional components don't have the ability for a constructor
export const useConstructor = (callBack: Function) => {
    const [hasBeenCalled, setHasBeenCalled] = React.useState(false);
    if (hasBeenCalled) return;
    callBack();
    setHasBeenCalled(true);
}
